import {SpacerProps} from './HSpacer';
import classes from './spacer.module.scss';

export const VSpacer = ({size = '2'}: SpacerProps) => {
  const className = `v-spacer-${size}`;
  return <div className={classes[className]} />;
};
